import React, { useState, useEffect, useCallback } from "react";


function Nilza({ ...props }) {
    const [url, setURL] = useState('')

  useEffect(() => {
    const token = localStorage.getItem('@inconta-token');
    const user = localStorage.getItem('@inconta-user')
    setURL(`${process?.env?.REACT_APP_URL_HELPDESK}/token/${encodeURIComponent(token)}/${encodeURIComponent(user)}`)    
  }, []);


  return (
        <div style={{width:"100%",height:"82vh"}}>
            <iframe src={url} frameBorder="0" style={{width:"100%",height:"100%", border:"none"}}></iframe>
        </div>
  );
}

export default Nilza;
